import { render, staticRenderFns } from "./SmallUserProfile.vue?vue&type=template&id=da2c8290&scoped=true"
import script from "./SmallUserProfile.vue?vue&type=script&lang=ts"
export * from "./SmallUserProfile.vue?vue&type=script&lang=ts"
import style0 from "./SmallUserProfile.vue?vue&type=style&index=0&id=da2c8290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2c8290",
  null
  
)

export default component.exports